// import Vue from 'vue'
import { au, fb, db } from '../plugins/firebase'
import { momento } from '../plugins/moment'
// import firebase from 'firebase/app'
// import 'firebase/auth'

export default {
  namespaced: true,
  state: {
    user: null
  },
  mutations: {
    user (state, p) {
      state.user = p
    }
  },
  actions: {
    ingreso (context, p) {
      let user = {
        correo: p.email,
        rut: '',
        telefono: '',
        nombres: '',
        apellidos: '',
        uid: '',
        permisos: {}
      }
      return new Promise((resolve, reject) => {
        au.signInWithEmailAndPassword(p.email, p.pass)
        .then(data => {
          user.uid = data.user.uid
          context.dispatch('seguirIngreso', user)
          resolve({logged: true, status: 'Login exitoso'})
          // return db.ref('usuarios').child(user.uid).once('value')
        })
        // .then(snap => {
        //   if (snap.val().conectado) {
        //     context.dispatch('detenerIngreso')
        //     reject({logged: false, status: 'Usuario en uso'})
        //   } else { 
        //     context.dispatch('seguirIngreso', user)
        //     resolve({logged: true, status: 'Login exitoso'})
        //   }
        // })
        .catch(() => {
          context.dispatch('detenerIngreso')
          reject({logged: false, status: 'Error en inicio de sesión'})
        })
      })
    },
    seguirIngreso (context, p) {
      getDatos(p.uid)
      .then(datos => {
        p.correo = datos.correo || ''
        p.nombres = datos.nombres || ''
        p.rut = datos.rut || ''
        p.telefono = datos.telefono || ''
        p.apellidos = datos.apellidos || ''
        return getPermisos(p.uid)
      })
      .then(permisos => {
        p.permisos = permisos
        context.commit('user', p)
        //return loggeado(p)
      })
      // .then(() => {
      //   context.commit('user', p)
      // })
    },
    detenerIngreso (context) {
      au.signOut()
      .then(() => {
        context.commit('user', null)
      })
    },
    out (context) { //p
      return new Promise ((resolve, reject) => {
        au.signOut()
        // .then(() => {
        //   return desconectado(p)
        // })
        .then(() => {
          context.commit('user', null)
          resolve(true)
        })
        .catch(() => {
          reject(false)
        })
      })
    },
    auto (context, p) {
      if (p.email !== undefined && p.uid !== undefined) {
        context.dispatch('seguirIngreso', p)
        // db.ref('usuarios').child(p.uid).once('value')
        // .then(snap => {
        //   if (snap.val().conectado) {
        //     context.dispatch('detenerIngreso')
        //   } else { 
        //     context.dispatch('seguirIngreso', p)
        //   }
        // })
      } else
        context.commit('user', null)
    },
    disconnect (context, uid) {
      desconectado(uid)
    },
    crearCuenta (ctx, p) {
      let usuario = p
      return new Promise ((resolve, reject) => {
        au.createUserWithEmailAndPassword(p.correo, p.pass)
        .then(data => {
          // au.setPersistence(firebase.auth.Auth.Persistence.LOCAL)
          usuario.uid = data.user.uid
          usuario.form = true
          delete usuario.pass
          return fb.collection('clientes').doc(usuario.uid).set(usuario)
        })
        .then(() => {
          ctx.commit('user', usuario)
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    }
  },
  getters: {
    user: state => state.user
  }
}

function getDatos (uid) {
  return new Promise ((resolve, reject) => {
    fb.collection('clientes').doc(uid).get()
    .then(doc => {
      if (doc.exists)
        resolve(doc.data())
      else
        resolve({})
    })
    .catch(() => {
      reject({})
    })
  })
}

function getPermisos (uid) {
  return new Promise ((resolve, reject) => {
    fb.collection('permisos').doc(uid).get()
    .then(doc => {
      if (doc.exists)
        resolve(doc.data())
      else
        resolve()
    })
    .catch(() => {
      reject({})
    })
  })
}

// function loggeado (user) {
//   return new Promise ((resolve, reject) => {
//     let data = {
//       user: user.correo,
//       conectado: true,
//       connected: momento().format()
//     }
//     db.ref('usuarios').child(user.uid).update(data)
//     .then(() => {
//       resolve()
//     })
//     .catch(() => {
//       reject()
//     })
//   })
// }

function desconectado (uid) {
  return new Promise ((resolve, reject) => {
    let data = {
      conectado: false,
      disconnected: momento().format()
    }
    db.ref('usuarios').child(uid).update(data)
    .then(() => {
      resolve()
    })
    .catch(() => {
      reject()
    })
  })
}